import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/redux/hooks';
import { userSelectors } from '@/redux/selectors';
import { Button, SvgIcon } from '@/components';

import styles from './BehavioralAlertsNoData.module.sass';

interface BehavioralAlertsNoDataProps {
  onAddRule: () => void;
}

export const BehavioralAlertsNoData = ({
  onAddRule,
}: BehavioralAlertsNoDataProps) => {
  const { t } = useTranslation();
  const complianceActivated = useAppSelector(userSelectors.complianceActivated);

  return (
    <div className={styles.empty}>
      <SvgIcon name="empty-data" className={styles.icon} />

      <div className={styles.title}>
        {t('translation.no_behavioral_alerts.title')}
      </div>

      <div className={styles.description}>
        {t('translation.no_behavioral_alerts.description')}
      </div>

      {complianceActivated && (
        <Button corner="rect" type="primary" size="s" onClick={onAddRule}>
          <SvgIcon name="plus" />
          <span>{t('translation.create_alert_rule')}</span>
        </Button>
      )}
    </div>
  );
};
